import { City } from "@/sharedTypes";
import { baseApi } from "../baseApi";

const cityTag = "City";

export const cityApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCities: builder.query<any, Record<string, any> | void>({
      query: (params) => {
        const searchParams = new URLSearchParams();

        if (params) {
          const { filters, pagination } = params as any;

          if (filters) {
            Object.entries(filters).forEach(([key, value]) => {
              if (value !== undefined && value !== null && value !== "") {
                searchParams.append(key, String(value));
              }
            });
          }

          if (pagination) {
            Object.entries(pagination).forEach(([key, value]) => {
              if (value !== undefined && value !== null) {
                searchParams.append(key, String(value));
              }
            });
          }
        }

        const queryString = searchParams.toString();
        return `/gw/cities${queryString ? `?${queryString}` : ""}`;
      },
      providesTags: [cityTag],
    }),
    createCity: builder.mutation({
      query: (payload: City) => ({
        url: "/gw/cities",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: [cityTag],
    }),
    updateCity: builder.mutation({
      query: ({ id, ...payload }: City) => ({
        url: `/gw/cities/${id}`,
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: [cityTag],
    }),
    deleteCity: builder.mutation({
      query: (id: number) => ({
        url: `/gw/cities/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [cityTag, "District", "LocationAlias"],
    }),
  }),
});

export const {
  useGetCitiesQuery,
  useCreateCityMutation,
  useUpdateCityMutation,
  useDeleteCityMutation,
} = cityApi;
